import {Spin} from "antd";
import {useParams} from "react-router-dom";
import React, {useEffect} from "react";
import useNewsController from "../../../controllers/news-controller";
import NewsItemPageHeader from "./components/page-header/NewsItemPageHeader";
import NewsItemPageBody from "./components/page-body/NewsItemPageBody";
import ScrollToTopButton from "../../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less"


const NewsItemPage = () => {
  const {newsId} = useParams()
  const {isLoading, getNewsItemById, selectedNewsItem} = useNewsController()

  useEffect(() => {
    if (newsId) getNewsItemById(newsId)
  }, [newsId])


  return <div className="news-item-page">
    <div className="news-item-page__navigation">
      <NewsItemPageHeader/>
    </div>
    <main className="news-item-page__content">
      {isLoading ? <Spin spinning={isLoading} size="large" fullscreen/> :
        <NewsItemPageBody currentNewsItem={selectedNewsItem}/>}
    </main>
    <ScrollToTopButton elementSelector={".news-item-page__content"}/>
  </div>
}
export default NewsItemPage
